const ON_CLIENT = typeof window !== 'undefined';
const ON_SERVER = !ON_CLIENT;

export { ON_CLIENT, ON_SERVER };
